import React, { useEffect, useState } from "react"
import { useDebounce } from "use-debounce"
import ExpenseFilter from "./ExpenseFilter"
import { WBLabel } from "components/_WBcomponents/WBLabel"
import WBAccordion from "components/_WBcomponents/WBAccordion"
import { Grid, Button, Dialog, Card, CardContent } from "@mui/material"
import WBTable from "components/_WBcomponents/WBTable"
import { isSuperAdmin } from "helper/localStorage"
import moment from "moment"
import { currencyFormat } from "helper/numberHelper"
import ExpenseForm from "./ExpenseForm"
import { deleteExpenseService, getExpenseList } from "services/expenseService"
import ExpenseDetail from "./ExpenseDetail"
import { toast } from "react-toastify"

function ExpenseList ({
    
}) {

    const [ loading, setLoading ] = useState(false)
    const [ openDialog, setOpenDialog ] = useState({
        data: null,
        expenseId: null,
        open: false
    })

    const [ filter, setFilter ] = useState({
        dateType: { label: '<>', value: 'ib'},
        startDate: moment().add(-7, 'day'),
        endDate: moment(),
        expenseType: null,
        requestBy: null,
        eventId: null,
        page: 0,
        limit: 20
    })

    const [ expenses, setExpenses ] = useState([])
    const [ summaryExpense, setSummaryExpense ] = useState(0)
    const [ totalData, setTotalData ] = useState(0)

    const [ debounceFilter ] = useDebounce(filter, 500)
    
    useEffect(() => {
        loadExpense()
    }, [debounceFilter])

    const onChangePage = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e
        }))
    }

    const loadExpense = async () => {
        setLoading(true)
        let { data, error } = await getExpenseList({
            ...filter,
            dateType: filter.dateType ? filter.dateType.value : '',
            expenseType: filter.expenseType ? filter.expenseType.label : '',
            requestBy: filter.requestBy ? filter.requestBy.value : '',
            eventId: filter.eventId ? filter.eventId.value : '',
        })
        setLoading(false)
        if (error) { toast.error(error) }
        if (data) {
            setExpenses(data.data)
            setSummaryExpense(data.expenseTotal || 0)
            setTotalData(data.totalData || 0)
        }
    }

    const deleteExpense = async (id) => {
        let { data, error } = await deleteExpenseService({
            _id: id
        })
        if (error) { toast.error(error) }
        if (data) {
            setOpenDialog({
                data: null,
                expenseId: null,
                open: false
            })
            toast.success("Expense deleted")
            loadExpense()
        }
    }

    const onChangeFilter = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e,
            page: 0
        }))
    }

    const valueCustomator = (data) => {
        return {
            expenseDate: <WBLabel>{moment(data.createdDate).format('DD-MM-YYYY HH:mm')}</WBLabel>,
            type: <WBLabel>{data.expenseType ? data.expenseType.name : "-"}</WBLabel>,
            event: <WBLabel>{data.eventId ? data.eventId.eventName : "-"}</WBLabel>,
            admin: <WBLabel>{data.requestBy ? data.requestBy.name : '-'}</WBLabel>,
            nominal: <WBLabel>{currencyFormat(data.nominal)}</WBLabel>,
            action: <Grid container textAlign={"right"} spacing={2} p={1} justifyContent={"right"}>
                <div style={{display: 'flex'}}>
                <div style={{ marginRight: 2, minWidth: 70, textAlign: 'center' }}>
                        <Button color="primary" variant="contained" disabled={data._id.toString() === "66eee6b3d996a9edf2f856ae"} onClick={() => {
                            setOpenDialog({
                                open: true,
                                data: data,
                                expenseId: null
                            })
                        }}>Detail</Button>
                    </div>
                    <div style={{ marginRight: 2, minWidth: 70, textAlign: 'center' }}>
                        <Button color="error" variant="contained" disabled={data._id.toString() === "66eee6b3d996a9edf2f856ae"} onClick={() => {
                            setOpenDialog({
                                open: true,
                                data: null,
                                expenseId: data._id
                            })
                        }}>Delete</Button>
                    </div>
                </div>
            </Grid>,
        }
    }

    return (
        <Grid>
            <Grid sx={{mb: 1}}>
                <Grid mb={1}>
                    <Button variant="contained" onClick={() => {
                        setOpenDialog({
                            data: null,
                            open: true
                        })
                    }}>Add New Expense</Button>
                </Grid>
                <WBAccordion title={<WBLabel style={{fontWeight: 'bold'}}>{"Expense Filter"}</WBLabel>}>
                    <ExpenseFilter
                        filter={filter}
                        onChangeFilter={onChangeFilter}
                        onClear={() => {
                            setFilter({
                                dateType: { label: '<>', value: 'ib'},
                                startDate: null,
                                endDate: null,
                                orderCode: '',
                                event: null,
                                eventId: null,
                                requestBy: null,
                                customer: null,
                                status: null,
                                expenseType: null,
                                page: 0,
                                limit: 20
                            })
                        }}
                    />
                </WBAccordion>
            </Grid>
            <Grid container sx={{mb: 1}} spacing={1}>
                <Grid item xs={6} md={4}>
                    <Card>
                        <CardContent>
                            <WBLabel><span style={{ fontWeight: 'bold' }}>Total Expense {moment(filter.startDate).format('DD-MM-YYYY')} - {moment(filter.endDate).format('DD-MM-YYYY')}</span></WBLabel>
                            <div style={{ fontWeight: 'bold' }}>{currencyFormat(summaryExpense)}</div>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid>
                <WBTable
                    columns={[
                        { label: "Expense Date" },
                        { label: "Expense Type" },
                        { label: "Event" },
                        { label: "Admin" },
                        { label: "Nominal" },
                        { label: "" },
                    ]}
                    loading={loading}
                    valueCustomator={valueCustomator}
                    totalData={totalData}
                    rows={expenses}
                    page={filter.page}
                    pageChange={(e) => {
                        onChangePage({page: e})
                    }}
                    rowsPerPage={filter.limit}
                    onRowsPerPageChange={(limit) => {
                        onChangeFilter({limit: Number(limit)})
                    }}
                    emptyMessage="No expenses match the filter"
                />
            </Grid>
            <Dialog fullWidth={false} open={openDialog.open && openDialog.expenseId} onClose={() => {
                setOpenDialog({
                    data: null,
                    expenseId: null,
                    open: false
                })
            }}>
                <Grid container p={2}>
                    <Grid item xs={12}>
                        <WBLabel>
                            Are you sure you want to delete this expense ?
                        </WBLabel>
                    </Grid>
                    <Grid item xs={12} textAlign={"right"} mt={1}>
                        <Button onClick={() => {
                            deleteExpense(openDialog.expenseId)
                        }} color="error">{"Delete"}</Button>
                        <Button onClick={() => { setOpenDialog({
                            open: false,
                            data: null,
                            expenseId: null
                        }) }}>{"Cancel"}</Button>
                    </Grid>
                </Grid>
            </Dialog>
            <Dialog fullWidth={false} open={openDialog.open && openDialog.data} onClose={() => {
                setOpenDialog({
                    data: null,
                    expenseId: null,
                    open: false
                })
            }}>
                {
                    openDialog.data &&
                    <Grid container p={2}>
                        <ExpenseDetail data={openDialog.data} />
                    </Grid>
                }
            </Dialog>
            <Dialog fullWidth={false} open={openDialog.open && !openDialog.expenseId && !openDialog.data} onClose={() => {
                setOpenDialog({
                    data: null,
                    expenseId: null,
                    open: false
                })
            }}>
                <Grid>
                    <Grid pl={2} pr={2} pt={2} pb={2}>
                        <WBLabel style={{fontWeight: 'bold', fontSize: 16}}>Add new Expense</WBLabel>
                    </Grid>
                    <ExpenseForm loadData={() => {
                        setOpenDialog({
                            data: null,
                            expenseId: null,
                            open: false
                        })
                        loadExpense()
                    }} />
                </Grid>
            </Dialog>
        </Grid>
    )
}

export default ExpenseList